<template>
  <v-row>
    <v-col cols="auto" class="pl-12 my-auto">
      <v-icon :color="iconColor">
        {{ icon }}
      </v-icon>
    </v-col>
    <v-col class="my-auto">
      {{ question.question }}
    </v-col>
    <v-spacer></v-spacer>
    <v-col cols="auto">
      <v-menu absolute>
        <template v-slot:activator="{ on, attrs }">
          <v-btn v-bind="attrs" v-on="on" icon>
            <v-icon>more_vert</v-icon>
          </v-btn>
        </template>
        <v-list>
          <v-list-item @click="$emit('moveup')" v-if="allowUp">
            <v-list-item-icon>
              <v-icon>arrow_upward</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Move up</v-list-item-title>
          </v-list-item>
          <v-list-item @click="$emit('movedown')" v-if="allowDown">
            <v-list-item-icon>
              <v-icon>arrow_downward</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Move down</v-list-item-title>
          </v-list-item>
          <v-list-item @click="showEditQuestion">
            <v-list-item-icon>
              <v-icon>edit</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Edit</v-list-item-title>
          </v-list-item>
          <v-list-item @click="deleteQuestion">
            <v-list-item-icon>
              <v-icon>delete</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Delete</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-col>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import questionTypes from "@/helpers/mixins/questionTypes";
export default {
  components: {},
  name: "AnnualReviewQuestionItem",
  mixins: [questionTypes],
  props: {
    question: { type: Object },
    allowUp: { type: Boolean, default: false },
    allowDown: { type: Boolean, default: false }
  },
  data: () => ({
    saving: false,
    loading: false,
    valid: false
  }),
  computed: {
    icon() {
      return this.getQuestionTypeIcon(this.question.questionTypeId);
    },
    iconColor() {
      return this.getQuestionTypeColor(this.question.questionTypeId);
    },
    ...mapGetters({})
  },
  created() {},
  methods: {
    showEditQuestion() {
      this.$emit("edit");
    },
    async deleteQuestion() {
      if (
        await this.$root.$confirm(
          "Delete question",
          "Are you sure you want to delete this question?",
          { color: "red" }
        )
      ) {
        this.saving = true;
        this.$store
          .dispatch("settings/deleteAnnualReviewQuestion", this.question)
          .then(() => {
            this.$emit("save");
            this.$root.$snackbarSuccess("Question deleted");
          })
          .catch(error => {
            this.logError(error);
            this.$root.$alert(
              "Error Occurred",
              "An error occured while deleting a question."
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    }
  }
};
</script>
